define(['angular', 'lodash', 'moment'], function(angular, _, moment) {

    function BusinessCtrl($scope, $rootScope, $uibModal, $log, walletService, Notification, userService, storeService, orderFormService) {
        let self = this;
        let store = $scope.storeCtrl.store;
        self.isTeleproForm = $scope.storeCtrl.isTeleproForm;
        self.wallet = [];

        self.dt = $('#business');

        self.business = {
            nbCheckouts: 1,
            userIdRef: $rootScope.user.uid
        };

        self.columns = [
            {
                data: 'businessId',
                title: '#',
            },
            {
                data: 'storeId',
                title: 'Identifiant magasin',
                visible: false
            },
            {
                data: 'lastName',
                title: 'Nom',
                visible: false
            },
            {
                data: 'department',
                title: 'Dép',
                visible: false
            },
            {
                data: 'addressCity',
                title: 'Ville',
                visible: false
            },
            {
                data: 'scenarioTypeLabel',
                title: 'Type'
            },
            {
                data: 'RDS',
                title: 'RDS',
                render: function(data) {
                    const user = userService.findPerson(data);
                    return user ? user.user.displayName : data;
                }
            },
            {
                data: 'nombreCaisse',
                title: 'Nombre de caisse'
            },
            {
                data: 'orderTypeLabel',
                title: 'Réseau',
                defaultContent: ''
            },
            {
                data: 'storeActivityLabel',
                title: 'Marché',
                defaultContent: ''
            },
            {
                data: 'dateFinContrat',
                title: 'Fin de contrat',
                render: function(data) {
                    return data !== null ? moment(data).format('YYYY-MM-DD') : null;
                }
            },
            {
                data: 'commentaireRds',
                title: 'Commentaire RDS',
                defaultContent: ''
            },
            {
                data: 'commentaireCs',
                title: 'Commentaire CS',
                defaultContent: ''
            },
            {
                data: 'businessStatusLabel',
                title: 'Etat',
                defaultContent: ''
            },
            {
                data: 'userRef',
                title: 'Gestionnaire'
            },
            {
                data: 'userRefRole',
                title: 'Rôle'
            },
            {
                data: 'moisSignature',
                title: 'Mois signature',
                render: function(data) {
                    return data !== null ? moment(data).format('MMMM YYYY') : null;
                }
            },
            {
                data: 'moisRelance',
                title: 'Mois Relance',
                render: function(data) {
                    return data !== null ? moment(data).format('MMMM YYYY') : null;
                }
            },
            {
                data: 'dateRdv',
                title: 'Date RDV',
                render: function(data) {
                    return data !== null ? moment(data).format('DD/MM/YYYY HH:mm') : null;
                }
            },
            {
                data: 'provenance',
                title: 'Provenance'
            },
            {
                data: 'dateModificationStatus',
                title: 'Modif Status',
                visible: false,
                render: function(data) {
                    return data !== null ? moment(data).format('DD/MM/YYYY') : null;
                }
            },
            {
                data: 'dateModification',
                title: 'Dernière modif',
                visible: true,
                render: function(data) {
                    return data !== null ? moment(data).format('DD/MM/YYYY HH:mm') : null;
                }
            }
        ];

        self.prepareUpdate = function(id) {
            self.businessToUpdate = id;
            _openModalUpdateBusiness('lg');
        };

        function _openModalUpdateBusiness(size) {
            let _updateBusinessModal = $uibModal.open({
                animation: true,
                templateUrl: 'updateBusiness.html',
                controller: 'UpdateBusinessCtrl',
                controllerAs: 'updateBusinessCtrl',
                size: size,
                resolve: {
                    business: function() {
                        return self.wallet.filter(business => business.businessId === self.businessToUpdate);
                    },
                    scenarioType: function() {
                        return self.types;
                    },
                    orderType: function() {
                        return self.networks;
                    },
                    storeActivity: function() {
                        return self.activities;
                    },
                    status: function() {
                        return self.status;
                    },
                    users: function() {
                        return self.users;
                    },
                    store: function() {
                        return store;
                    }
                }
            });
            _updateBusinessModal.result.then(function(data) {
                if(data.delete){
                    _delete(data.business)
                }else{
                    _confirmUpdate(data)
                }
            });
        }

        function _confirmUpdate(data) {
            let business = data.business;
            let store = data.store;
            $scope.storeCtrl.loadingStore = true;
            try {
                for (let i = 0; i < self.wallet.length; i++) {
                    if (self.wallet[i].businessId === self.businessToUpdate) {
                        if (!self.isValidDateFinContrat(store)) {
                            throw new Error('La date de fin de contrat ne peut pas être avant le 1 janvier 2000.');
                        }
                        self.wallet[i] = business;
                        walletService
                            .updateBusiness(self.wallet[i])
                            .then(function () {
                                $scope.storeCtrl.store.wallet = self.wallet;
                                self.table.clear().draw();
                                self.table.rows.add(self.wallet).draw();
                            })
                            .then(function () {
                                if (Object.keys(store.fieldsToWatch).length) {
                                    let isFieldToWatchModified;
                                    Object.keys(store.fieldsToWatch).forEach(field => {
                                        if (store.fieldsToWatch[field].new !== null) {
                                            $scope.storeCtrl.store.qualification.fin_contrat = store.qualification.fin_contrat;
                                        }
                                        isFieldToWatchModified =
                                            store.fieldsToWatch[field].old !== store.fieldsToWatch[field].new &&
                                            store.fieldsToWatch[field].new !== null;
                                    });
                                    if (isFieldToWatchModified && store.etat_magasin === 3) {
                                        return storeService.updateQualifications(store);
                                    }
                                }
                                Notification.success('Affaire mise à jour.');
                            })
                            .catch(function (err) {
                                Notification.error('Une erreur est survenue: ' + err.data);
                                $log.error(err);
                            }).finally(function () {
                            $scope.storeCtrl.loadingStore = false;
                        });
                        break;
                    }
                }
            }catch (err) {
                Notification.error('Une erreur est survenue: ' + err.data);
                $scope.storeCtrl.loadingStore = false;
            }
        }

        self.isValidDateFinContrat = (store) => {
            return !moment(store.qualification.fin_contrat).isBefore(moment([2000, 0, 1]));

        }

        function _delete(business) {
            for (let i = 0; i < self.wallet.length; i++) {
                if (self.wallet[i].businessId === self.businessToUpdate) {
                    self.wallet[i] = business;
                    walletService
                        .deleteBusiness(self.wallet[i])
                        .then(function() {
                            let id = store.client[0].id ? store.client[0].id : store.client[0].storeId;
                            return walletService.
                            getStoreBusinesses(id)
                                .then(res => {
                                    res.map(bus => {
                                        bus.department = bus.addressPostalCode.slice(0, 2);
                                    });
                                self.wallet = res;
                                $scope.storeCtrl.store.wallet = self.wallet;
                                    self.table.clear().draw();
                                    self.table.rows.add(self.wallet).draw();
                                Notification.success('Affaire supprimée.');
                            });
                        })
                        .catch(function(err) {
                            Notification.error('Une erreur est survenue: ' + err.data);
                            $log.error(err);
                        });
                    break;
                }
            }
        }

        /**
         * Open the client modal
         * @param  {String} size
         */
        self.openModalClient = function (size) {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'walletCreateUpdateClient.html', // modal/client.html
                controller: 'WalletCreateUpdateClientCtrl',
                controllerAs: 'walletCreateUpdateClientCtrl',
                size: size,
                resolve: {
                    client: function () {
                        return store.client;
                    },
                    storeTypes : function () {
                        return self.storeTypes;
                    },
                    activities: function () {
                        return self.activities;
                    },
                    store: function(){
                        return store;
                    }
                }
            });

            modal.result.then(function (data) {
                store.client[0] = data;
                console.log('Store', store);
            });
        };

        function _getUser() {
            userService.getUsers().then(res => {
                self.users = res;
                self.initiateur = self.users.filter(
                    tel =>
                        (tel.role === 'TELEPRO' || tel.role === 'CS' || tel.role === 'RDS') && tel.displayName !== null
                );
                self.initiateur.push($rootScope.user);
            });
        }

        self.getLastAppointmentComment = function(){
            self.business.comment = $scope.storeCtrl.store.appointments[0].comment;
        }

        function _getBusinessForm() {
            return walletService
                .getBusinessForm()
                .then(data => {
                    self.types = data.scenarioTypes;
                    self.networks = data.orderTypes;
                    self.activities = data.storeActivities;
                    self.status = data.status;
                })
                .catch(err => {
                    Notification.error('Une erreur est survenue : ' + err.data);
                });
        }

        function _getOrderForm() {
            return orderFormService
                .getOrderForm()
                .then(data => {
                    self.storeTypes = data.storeTypes;
                }).catch(err => {
                    Notification.error('Une erreur est survenue : ' + err.data);
                });
        }

        self.getStoreBusinesses = () => {
            let id = store.client[0].id ? store.client[0].id : store.client[0].storeId;
            return walletService.getStoreBusinesses(id).then(res => {
                res.map(bus => {
                    bus.department = bus.addressPostalCode.slice(0, 2);
                });
                self.wallet = res;
                $scope.storeCtrl.store.wallet = self.wallet;
                self.table = self.initDt(self.columns, res);
            });
        };

        self.createBusiness = () => {
            let user = self.users.filter(user => user.uid === self.business.userIdRef);
            let business = {
                businessStatusId: 1,
                scenarioTypeId: self.business.type,
                nombreCaisse: self.business.nbCheckouts,
                dateFinContrat: moment(storeService.getDateFinContrat(store)).isValid() ? moment(storeService.getDateFinContrat(store)).format('YYYY-MM-DD') : null,
                commentaireRds: $rootScope.user.role === 'RDS' ? self.business.comment : null,
                commentaireCs: $rootScope.user.role !== 'RDS' ? self.business.comment : null,
                moisSignature: moment(self.business.date).format('YYYY-MM-DD'),
                moisRelance: null,
                dateRdv: null,
                provenance: $rootScope.user.role === 'RDS' ? 'Création manuelle RDS' : 'Création manuelle Télépro/CS',
                userIdRef: self.business.userIdRef,
                clientId: store.client[0].id,
                managerRefId: user[0].parent,
                orderTypeId: self.business.network,
                storeActivityId: self.business.activity,
                dateModificationStatus: null,
                store: store
            };
            return walletService
                .createBusiness(business)
                .then(function(res) {
                    // Reset the form
                    res.department = res.addressPostalCode.slice(0, 2);
                    self.wallet.push(res);
                    $scope.storeCtrl.store.wallet = self.wallet;
                    self.table.clear().draw();
                    self.table.rows.add(self.wallet).draw();
                    self.business = { nbCheckouts: 1 };
                    self.businessForm.$setUntouched();
                    Notification.success('Affaire créée.');
                })
                .catch(err => {
                    Notification.error('Une Erreur est survenue : ' + err.data);
                });
        };

        self.initDt = function(cols, content) {
            const columns = _.cloneDeep(cols);
            const data = _.cloneDeep(content);

            let dtOptions = {
                data,
                columns,
                deferRender: true,
                retrieve: true,
                buttons: ['searchBuilder', 'colvis'],
                language: {
                    url: 'https://cdn.datatables.net/plug-ins/1.13.8/i18n/fr-FR.json'
                },
                responsive: true,
                // scrollX: true,
                paging: false,
                order: [[16, 'desc']],
                select: {
                    style: 'api',
                    toggleable: false
                },
                dom: 'Bft',
                initComplete: () => {
                    $scope.$emit('initComplete', self.table);
                    self.dt.on('click', 'td', function() {
                        const row = $scope.businessCtrl.table.row(this).data();
                        const cell = $scope.businessCtrl.table.cell(this).node();
                        if (row && !$scope.storeCtrl.isExt && cell.className !== 'dtr-control' && $scope.storeCtrl.store.etat_magasin !== 4) {
                            self.prepareUpdate(row.businessId);
                        }
                    });
                }
            };
            if(userService.isSalesAdmin($rootScope.user)){
                dtOptions.buttons = ['searchBuilder', 'csv', 'colvis']
            }
            return self.dt.DataTable(dtOptions);
        }

        _getBusinessForm();
        _getOrderForm();
        _getUser();
        self.getStoreBusinesses();

        return self;
    }

    BusinessCtrl.$inject = [
        '$scope',
        '$rootScope',
        '$uibModal',
        '$log',
        'walletService',
        'Notification',
        'userService',
        'storeService',
        'orderFormService'
    ];

    angular
        .module('app.prospection.store.businessCtrl', ['ui.bootstrap.modal', 'ui-notification'])
        .controller('BusinessCtrl', BusinessCtrl);
});
